var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBodyHeight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9231 0.5H3.07692C1.38031 0.5 0 1.88031 0 3.57692V13.4231C0 15.1197 1.38031 16.5 3.07692 16.5H12.9231C14.6197 16.5 16 15.1197 16 13.4231V3.57692C16 1.88031 14.6197 0.5 12.9231 0.5ZM8.79569 11.7572C9.036 11.5169 9.42554 11.5169 9.66585 11.7572C9.90615 11.9972 9.90615 12.3871 9.66585 12.6274L8.43538 13.8582C8.32 13.9735 8.16369 14.0385 8.00031 14.0385C7.83692 14.0385 7.68062 13.9735 7.56492 13.8582L6.33446 12.6274C6.09415 12.3871 6.09415 11.9972 6.33446 11.7572C6.57477 11.5169 6.96431 11.5169 7.20492 11.7572L7.38462 11.9372V5.06338L7.20492 5.24338C6.96462 5.48369 6.57508 5.48369 6.33446 5.24338C6.09415 5.00308 6.09415 4.61354 6.33446 4.37292L7.56492 3.14215C7.796 2.91138 8.20462 2.91138 8.43538 3.14215L9.66585 4.37292C9.90615 4.61323 9.90615 5.00277 9.66585 5.24338C9.54554 5.36338 9.38831 5.42338 9.23077 5.42338C9.07323 5.42338 8.916 5.36339 8.79569 5.24308L8.61569 5.06308V11.9369L8.79569 11.7572Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBodyHeight);
export default __webpack_public_path__ + "static/media/body-height.5d81490652d0de77260585ffa63f43e2.svg";
export { ForwardRef as ReactComponent };